module.exports = __webpack_public_path__ + "img/shipo-menu-children-tick-unfilled.1e2586fb.svg";